import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _find from "lodash/find";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useState } from 'react';
import { navigate } from 'gatsby';
import { Col, Container, Row } from 'react-grid-system';
import { injectIntl } from 'react-intl';
import { useFormState } from 'react-use-form-state';
import { Button, Input, FormLabel, Textarea } from '@chakra-ui/react';
import { useStaticQuery } from 'gatsby';
import * as S from './styles';
import routes from '../../../../config/routes';
import { jsx as ___EmotionJSX } from "@emotion/react";
function encode(data) {
  return Object.keys(data).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&');
}
const ContactForm = props => {
  const intl = props.intl.formatMessage;
  const data = useStaticQuery(query);
  const recipient_email = _find(data.directusCompany.emails, email => email.primary).email;
  const {
    0: loading,
    1: setLoading
  } = useState(false);
  const [formState, {
    email,
    label,
    text,
    textarea
  }] = useFormState({}, {
    withIds: true,
    validateOnBlur: true
  });
  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);
    fetch(`${process.env.GATSBY_ORDER_API_ENDPOINT}/atacama/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: encode(_objectSpread({
        hostname: document.location.host,
        recipient_email
      }, formState.values))
    }).then(res => {
      if (res.status === 500 || res.status === 404) {
        alert('E-Mail konnte nicht versendet werden. Bitte versuchen Sie es später erneut.');
        setLoading(false);
      } else if (res.status === 200) {
        setLoading(false);
        navigate(routes.thanks[props.intl.locale], {
          state: formState.values
        });
      }
    }).catch(error => {
      setLoading(false);
      console.log(error);
      alert('E-Mail konnte nicht versendet werden. Bitte versuchen Sie es später erneut.');
    });
  };
  return ___EmotionJSX(S.Form, {
    name: "contact",
    onSubmit: handleSubmit
  }, ___EmotionJSX(Container, {
    fluid: true
  }, ___EmotionJSX(Row, null, ___EmotionJSX(Col, {
    md: 6
  }, ___EmotionJSX(FormLabel, label('name'), intl({
    id: 'components.netlifyContactForm.name'
  })), ___EmotionJSX(Input, _extends({
    colorScheme: "base"
  }, text('name'), {
    placeholder: intl({
      id: 'components.netlifyContactForm.namePlaceholder'
    }),
    variant: "filled",
    required: true
  }))), ___EmotionJSX(Col, {
    md: 6
  }, ___EmotionJSX(FormLabel, label('email'), intl({
    id: 'components.netlifyContactForm.email'
  })), ___EmotionJSX(Input, _extends({}, email('email'), {
    placeholder: intl({
      id: 'components.netlifyContactForm.emailPlaceholder'
    }),
    required: true,
    variant: "filled"
  })))), ___EmotionJSX(Row, {
    style: {
      marginTop: '15px'
    }
  }, ___EmotionJSX(Col, {
    md: 12
  }, ___EmotionJSX(FormLabel, label('message'), intl({
    id: 'components.netlifyContactForm.message'
  })), ___EmotionJSX(Textarea, _extends({}, textarea('message'), {
    variant: "filled",
    placeholder: intl({
      id: 'components.netlifyContactForm.messagePlaceholder'
    }),
    required: true
  })))), ___EmotionJSX(Row, null, ___EmotionJSX(Col, null, ___EmotionJSX("div", {
    style: {
      textAlign: 'right'
    }
  }, ___EmotionJSX(Button, {
    mt: 6,
    colorScheme: "brand",
    type: "submit",
    isDisabled: loading,
    isLoading: loading
  }, intl({
    id: 'components.netlifyContactForm.submit'
  })))))));
};
export default injectIntl(ContactForm);
const query = "3040516786";